import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormControl, Input, InputAdornment, InputLabel, makeStyles, Table, TableBody, TableCell, TableFooter, TableHead, TableRow } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import {getFormData, setData} from '../store/slices/formDataSlice';
import {styled} from '@material-ui/core';
import { AlternateStyledTableRow, BlackCell, BlueGreyCell, BrightYellowCell, CellNoBorder, InstyleTable, StyledTableRow } from '../components/Page/TableStyles';

export const ElectricityCostPath = "/electricity-costs";
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    margin: theme.spacing(1),
  },
  block: {
    display: 'block',
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: '25ch',
  },
}));

//step 1 electricity costs page
export function ElectricityCosts(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const formData = useSelector(getFormData);

    const updateFormData = (key, value) => {
        dispatch(setData({
            prop: key,
            value: value
        }));
    }

    const formatMoney = (value) => {
        value = Math.round(value);
        return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: 'USD',
            currencyDisplay: 'narrowSymbol',
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
        }).format(value)
    }

    const billData = [{
        Bill: formData.yearlyPowerBill,
        Cumulative: formData.yearlyPowerBill,
        Tax: formData.yearlyPowerBill / (1 - (formData.taxRate / 100)),
        CumulativeTax: formData.yearlyPowerBill / (1 - (formData.taxRate / 100)),
    }];

    for(var i = 2; i < 11; i++) {
        var bill =  billData[i - 2].Bill * (1 + (formData.yearlyPriceIncrease / 100));
        var tax = bill / (1 - (formData.taxRate / 100))
        billData.push({
            Bill: bill,
            Cumulative: billData[i - 2].Cumulative + bill,
            Tax: tax,
            CumulativeTax: billData[i - 2].CumulativeTax + tax,
        })
    }

    //todo
    //1. background component of the instyle logo behind glass
    //2. tooltips to show what the tax rates are
    //3. styling of data on the page
    return (
        <div style={{position: 'relative'}}>
            {/* <div style={{position: 'absolute', left: 0, right: 0, top: 0}}>
                <Glass />
            </div> */}
            <div style={{padding: '10px 30px', width: '100%', height: '100%'}}>
                <div style={{width: '100%', height: '100%', display: 'grid', gridTemplateColumns: '1fr 2fr'}}>
                    <div id={'electric_cost--form'}>
                        <FormControl className={`${classes.margin} ${classes.block}`}>
                            <InputLabel htmlFor="standard-adornment-amount">Yearly Power Bill</InputLabel>
                            <Input
                                style={{minWidth: '200px'}}
                                id="standard-adornment-amount"
                                value={formData.yearlyPowerBill}
                                onChange={(e) => updateFormData('yearlyPowerBill', parseInt(e.target.value) || 0)}
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            />
                        </FormControl>
                        <FormControl className={`${classes.margin} ${classes.block}`}>
                            <InputLabel htmlFor="standard-adornment-amount">Yearly % Increase</InputLabel>
                            <Input
                                style={{minWidth: '200px'}}
                                id="standard-adornment-amount"
                                type={'number'}
                                inputProps={{min: 0, max: 100}}
                                value={formData.yearlyPriceIncrease.toString()}
                                onChange={(e) => updateFormData('yearlyPriceIncrease', parseInt(e.target.value) || 0)}
                                endAdornment={<InputAdornment position="end">%</InputAdornment>}
                            />
                        </FormControl>
                        <FormControl className={`${classes.margin} ${classes.block}`}>
                            <InputLabel htmlFor="standard-adornment-amount">Increase Next 12 Months</InputLabel>
                            <Input
                                style={{minWidth: '200px'}}
                                id="standard-adornment-amount"
                                type={'number'}
                                inputProps={{min: 0, max: 100}}
                                value={formData.twelveMonthIncrease.toString()}
                                onChange={(e) => updateFormData('twelveMonthIncrease', parseInt(e.target.value) || 0)}
                                endAdornment={<InputAdornment position="end">%</InputAdornment>}
                            />
                        </FormControl>
                        <FormControl className={`${classes.margin} ${classes.block}`}>
                            <InputLabel htmlFor="standard-adornment-amount">Tax Rate <HelpIcon style={{position: 'relative', top: '4px'}} fontSize={'small'} /></InputLabel>
                            <Input
                                style={{minWidth: '200px'}}
                                id="standard-adornment-amount"
                                value={formData.taxRate.toString()}
                                onChange={(e) => updateFormData('taxRate', parseInt(e.target.value) || 0)}
                                endAdornment={<InputAdornment position="end">%</InputAdornment>}
                            />
                        </FormControl>
                    </div>
                    <div>
                        <InstyleTable size={'small'}>
                            <TableHead >
                                <TableRow>
                                    <BrightYellowCell>Year</BrightYellowCell>
                                    <BrightYellowCell>Yearly Bill</BrightYellowCell>
                                    <BrightYellowCell>Cumulative Bills</BrightYellowCell>
                                    <CellNoBorder>&nbsp;</CellNoBorder>
                                    <BlueGreyCell style={{border: '1px solid white'}}>Taxable Earnings</BlueGreyCell>
                                    <BlueGreyCell style={{border: '1px solid white'}}>Cumulative Taxable</BlueGreyCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    billData.map((data, ix) => {
                                        var cell = <TableCell>{formatMoney(data.Cumulative)}</TableCell>
                                        if (ix == 4) {
                                            cell = <BrightYellowCell style={{fontWeight: 800}}>{formatMoney(data.Cumulative)}</BrightYellowCell>
                                        }
                                        return <StyledTableRow key={`billdata-${ix}`}>
                                            <BlueGreyCell>{ix + 1}</BlueGreyCell>
                                            <TableCell>{formatMoney(data.Bill)}</TableCell>
                                            { cell }
                                            <TableCell style={{backgroundColor: 'white'}}>&nbsp;</TableCell>
                                            <TableCell>{formatMoney(data.Tax)}</TableCell>
                                            <TableCell>{formatMoney(data.CumulativeTax)}</TableCell>
                                        </StyledTableRow>
                                    })
                                }
                                <TableRow>
                                    <BlackCell style={{color: 'red', fontWeight: 800}}>TOTAL</BlackCell>
                                    <BrightYellowCell style={{fontWeight: 800}}>{formatMoney(billData[billData.length - 1].Cumulative)}</BrightYellowCell>
                                    <CellNoBorder style={{backgroundColor: 'white'}}>&nbsp;</CellNoBorder>
                                    <CellNoBorder style={{backgroundColor: 'white'}}>&nbsp;</CellNoBorder>
                                    <BrightYellowCell style={{fontWeight: 800}}>{formatMoney(billData[billData.length - 1].CumulativeTax)}</BrightYellowCell>
                                    <CellNoBorder style={{backgroundColor: 'white'}}>&nbsp;</CellNoBorder>
                                </TableRow>
                            </TableBody>
                        </InstyleTable>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ElectricityCosts;